
/* Lets the services behind the admin panel redirect on a 403 without router
   access. The endpoints in AdminPanelFunction.cs answer 403 when the signed-in
   user is not an admin, which AdminRoute would already have caught on
   navigation -- so reaching one means admin rights went away mid-session.
   Sending the user home re-runs that guard.

   Note the admin-only endpoints are not all served by AdminPanelService:
   LeadershipCoverageDetails, FiscalYearList and ActiveShareholderList are
   guarded the same way but are called from shared services, so those callers
   opt in individually rather than the whole service file doing so. */

let redirectHome: (() => void) | null = null;

export const setAdminAccessDeniedRedirect = (fn: () => void) => {
  redirectHome = fn;
};

export const triggerAdminAccessDenied = () => {
  if (redirectHome) redirectHome();
};

export const redirectHomeOnForbidden = (error: any) => {
  if (error?.response?.status === 403) {
    triggerAdminAccessDenied();
  }
};
